export const BASE_URL = 'https://aicopyevaluator.com';

export const seoConfig = {
  home: {
    title: 'Parakh - AI Copy Evaluator',
    description:
      'Get instant, detailed AI feedback on your answer sheets. Analyze structure, content, and relevance with our advanced AI engine.',
    keywords: [
      'AI Answer Evaluation',
      'Answer Writing Feedback',
      'Answer Sheet Analysis',
      'Exam Preparation',
      'AI Grading',
      'Copy Checking',
    ],
    url: `${BASE_URL}/`,
    type: 'website',
  },

  schools: {
    title: 'Schools - Parakh AI Evaluator',
    description:
      'AI-powered answer evaluation solution designed for schools. Streamline grading, provide instant feedback, and improve student performance.',
    keywords: [
      'Schools answer evaluation',
      'Student answer feedback',
      'Exam grading',
      'Educational AI tools',
    ],
    url: `${BASE_URL}/schools`,
    type: 'website',
  },

  universities: {
    title: 'Universities - Parakh AI Evaluator',
    description:
      'Higher education answer evaluation platform. Evaluate exam answers at scale with AI-powered insights for universities.',
    keywords: [
      'University answer evaluation',
      'Higher education grading',
      'College exam feedback',
      'Academic assessment tools',
    ],
    url: `${BASE_URL}/universities`,
    type: 'website',
  },

  coaching: {
    title: 'Coaching Centers - Parakh AI Evaluator',
    description:
      'Answer evaluation solution for coaching centers. Evaluate and provide instant feedback on student answers to improve test preparation.',
    keywords: [
      'Coaching center tools',
      'Test preparation feedback',
      'Answer evaluation software',
      'Student mock test analysis',
    ],
    url: `${BASE_URL}/coaching`,
    type: 'website',
  },

  resources: {
    title: 'Resources - Parakh AI Evaluator',
    description:
      'Explore case studies, blog articles, sample reports, and rubric templates to learn how to use AI for answer evaluation.',
    keywords: [
      'Educational resources',
      'Answer evaluation guides',
      'AI tools for teachers',
      'Rubric templates',
    ],
    url: `${BASE_URL}/resources`,
    type: 'website',
  },

  blog: {
    title: 'Blog - Parakh AI Evaluator',
    description:
      'Read articles and insights about answer evaluation, AI in education, and best practices for student assessment.',
    keywords: ['Education blog', 'AI education', 'Answer writing tips', 'Student assessment'],
    url: `${BASE_URL}/resources/blog`,
    type: 'website',
  },

  caseStudy: {
    title: 'Case Studies - Parakh AI Evaluator',
    description:
      'Discover how schools and universities improved student outcomes using AI-powered answer evaluation.',
    keywords: ['Case studies', 'Education success stories', 'AI implementation'],
    url: `${BASE_URL}/resources/case-study`,
    type: 'website',
  },

  sampleReports: {
    title: 'Sample Reports - Parakh AI Evaluator',
    description:
      'View sample evaluation reports to understand the detailed feedback our AI provides on student answers.',
    keywords: ['Sample reports', 'Evaluation examples', 'Answer feedback examples'],
    url: `${BASE_URL}/resources/sample-reports`,
    type: 'website',
  },

  rubricTemplates: {
    title: 'Rubric Templates - Parakh AI Evaluator',
    description:
      'Download and customize rubric templates for answer evaluation and student assessment.',
    keywords: ['Rubric templates', 'Assessment rubrics', 'Grading templates'],
    url: `${BASE_URL}/resources/rubric-templates`,
    type: 'website',
  },

  about: {
    title: 'About Us - Parakh AI Evaluator',
    description:
      'Learn about Parakh, our mission to revolutionize educational assessment, and our team.',
    keywords: ['About us', 'Company mission', 'Educational technology'],
    url: `${BASE_URL}/company/about`,
    type: 'website',
  },

  careers: {
    title: 'Careers - Parakh AI Evaluator',
    description:
      'Join our team at Parakh. We are hiring talented professionals to build the future of educational AI.',
    keywords: ['Careers', 'Jobs', 'Employment', 'Join us'],
    url: `${BASE_URL}/company/careers`,
    type: 'website',
  },

  trust: {
    title: 'Trust & Security - Parakh AI Evaluator',
    description:
      'Learn about our commitment to data security, privacy, and trust in educational technology.',
    keywords: ['Security', 'Privacy', 'Data protection', 'Compliance'],
    url: `${BASE_URL}/company/trust`,
    type: 'website',
  },

  support: {
    title: 'Support - Parakh AI Evaluator',
    description:
      'Get help and support for using Parakh. Find FAQs, documentation, and contact support.',
    keywords: ['Support', 'Help', 'Documentation', 'FAQ'],
    url: `${BASE_URL}/support`,
    type: 'website',
  },
};

export const getStructuredData = (type: 'organization' | 'webpage') => {
  const baseData = {
    '@context': 'https://schema.org',
  };

  if (type === 'organization') {
    return {
      ...baseData,
      '@type': 'Organization',
      name: 'Parakh',
      url: BASE_URL,
      description: 'AI-powered answer evaluation platform for educational institutions',
      foundingDate: '2024',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'Customer Support',
        email: 'support@parakh.com',
      },
    };
  }

  return {
    ...baseData,
    '@type': 'WebPage',
    publisher: {
      '@type': 'Organization',
      name: 'Parakh',
      url: BASE_URL,
    },
  };
};
